export default __webpack_public_path__ + "static/media/clock_arrow_down.22b858b9.svg";